import template from './suburban-building-status.jade';
import validation from '../../../services/validation';
import suburbanBuildingStatus from '../../../enums/suburban-building-status-house';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.commonSuburbanBuildingStatus', [])
  .directive('cianAfCommonSuburbanBuildingStatus', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'store',
      function (store) {
        this.suburbanBuildingStatusOptions = suburbanBuildingStatus;

        this.validation = validation(this.form, 'suburbanBuildingStatus');

        this.handleChange = () => {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'land_status');
        };
      },
    ],
    controllerAs: 'suburbanBuildingStatus',
    template,
  })).name;
